import { logGreyErrorFromAccounts } from 'owa-account-analytics';

import setSharedSourcesMutator from '../actions/setSharedSources';
import onSharedSourcesChanged from '../actions/onSharedSourcesChanged';
import getAccountBySourceId from '../selectors/getAccountBySourceId';
import type { AdditionalAccountInfo } from '../store/schema/AccountSourceList';

/**
 * Sets the shared sources and then notifies of changes to the shared sources
 * @param coprincipalSourceId SourceId of the account for which shared sources are to be set
 * @param sharedAccountInfo Information to be set
 */
export default function setSharedSources(
    coprincipalSourceId: string,
    sharedAccountInfo: AdditionalAccountInfo
): void {
    const account = getAccountBySourceId(coprincipalSourceId);
    if (!account) {
        // This should only happen if the account is removed while the network call(s) to get information
        // about shared mailboxes (auto-mapped or manually added) is happening.
        const e = new Error('AcctSetSharedSources-AccountNotFound');
        /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param, owa-custom-rules/telemetry-event-name-format -- (https://aka.ms/OWALintWiki)
         * BASELINE: DO NOT COPY/PASTE!
         * undefined
         *	> Argument at index 1 for logGreyErrorFromAccounts must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo
         (https://aka.ms/OWALintWiki)
                 * Baseline. Dev touching this file must update to pass the active MailboxInfo; Docs: https://aka.ms/owa-analytics-mailboxinfo
                 * undefined
                 *	> MailboxInfo must be passed into the function to identify the account.
                 (https://aka.ms/OWALintWiki)
                         * Baseline. DO NOT COPY AND PASTE! Grandfathering existing event names; Devs who touch this file should update Event Names to follow Outlook Telemetry Naming Standards
                         *	> Invalid Outlook telemetry EventName "AcctSetSharedSources-AccountNotFound": must contain only letters, numbers, or underscores. */
        logGreyErrorFromAccounts('AcctSetSharedSources-AccountNotFound', undefined, e);

        return;
    }

    setSharedSourcesMutator(coprincipalSourceId, sharedAccountInfo);
    onSharedSourcesChanged(account);
}
